<template>
    <div class="dashboard bookings sales analysis">
        <div class="head">
            <div class="title">Booking Analysis</div>
        </div>

        <div class="summary" v-if="totalCost > 0">
            <div class="item">
                <div class="count">{{ $n(totalCost, 'currency') }}</div>
                <div class="name">Bkg Value</div>
            </div>
            <div class="item">
                <div class="count">{{ $n(totalInv, 'currency') }}</div>
                <div class="name">Invoiced</div>
            </div>
            <div class="item">
                <div class="count">{{ $n(totalReceipt, 'currency') }}</div>
                <div class="name">Receipt</div>
            </div>
            <div class="item">
                <div class="count">{{ $n(pendingCost, 'currency') }}</div>
                <div class="name">Balance</div>
            </div>
        </div>

        <div class="box-white filter">
            <vs-collapse>
                <vs-collapse-item icon-arrow="expand_more">
                    <div slot="header">
                        Buscador
                    </div>
                    <div class="wrapper">
                        <div class="item">
                            <vs-input label="Referencia" v-model="reference"/>
                        </div>
                        <div class="item">
                            <div class="wrap">
                                <label for="">Fechas</label>
                                <vs-select  class="creSelect" v-model="typeDate">
                                    <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in filterDates" />
                                </vs-select>  
                            </div>
                            <input-date-picker v-model="date" :currentDate="date"></input-date-picker>                
                        </div>
                        <div class="item">
                            <label for="">Estado Reservación</label>
                            <multiselect v-model="stBookings" :options="bookStatus" :multiple="true" :max-height="160" placeholder="" 
                                :close-on-select="false" :clear-on-select="false" :preserve-search="false" label="DESCRIPTION" track-by="DESCRIPTION">
                                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} estados seleccionados</span></template>
                            </multiselect>
                        </div>
                        <div class="item relative">
                            <div class='autocompleteel'> 
                                <div class="form-row">
                                    <vs-input type="text" label="Agencia" v-model="searchText" @keyup='loadSuggestions'/>
                                    <div class='suggestionlist' v-if="suggestiondata.length">
                                        <ul> 
                                            <li v-for='(item,index) in suggestiondata' @click='itemSelected(index)' :key="index">  {{ item.NAME }} </li> 
                                        </ul>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <label for="">Agente</label>
                            <multiselect v-model="vendors" :options="consultants" :multiple="true" :max-height="160" placeholder="" open-direction="top"
                                :close-on-select="false" :clear-on-select="false" :preserve-search="false" label="NAME" track-by="NAME">
                                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} agentes seleccionados</span></template>
                            </multiselect>
                        </div>
                        <div class="item">
                            <vs-button color="primary"  @click="search()" type="filled" icon="search"></vs-button>
                            <vs-button color="warning"  @click="reset()" type="border" icon="backspace" 
                                v-if="date != '' || reference != ''  || vendors.length > 0 || agencies.length > 0 || stBookings.length > 0"></vs-button>
                        </div>
                    </div>
                    <div class="tags">
                        <div class="wrapper-tags">
                            <template v-for="(item, idx) in agencies">
                                <vs-chip :key="idx" transparent color="primary" closable @click="removeAgency(item)">{{ item.NAME }}</vs-chip>
                            </template>
                        </div>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
        </div>

        <div class="bookings-wrapper">
            <table-booking-analysis :items="bkAnalysis"></table-booking-analysis>
        </div>


    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
// import pagination from '@/components/Pagination.vue'
import tableBookingAnalysis from '@/components/Tables/BookingAnalysis.vue'
import inputDatePicker from '@/components/Inputs/input-date-range.vue'
import BookingService from '@/services/BookingService'
import CatalogService from '@/services/CatalogService'
const  { mapActions: mapAppSettingActions } = createNamespacedHelpers('appSetting')

export default {
    name: "BookingsView",
    components: {
        // pagination,
        tableBookingAnalysis,
        inputDatePicker
    },
    data () {
        return {
            bkAnalysis: [],
            key: 1,
            totalPost: 26,
            date: "",
            value: "All",
            reference: "",
            modalShow: true,
            codeAccess: "",
            errorCode: false,
            status: "",
            disabled: false,
            stBookings: [],
            bookStatus: [],
            types: [],
            vendors: [],
            agencies: [],
            consultants:[],
            searchText: "",
            suggestiondata:[],
            typeDate: "Booking_Last_Service_Date",
            filterDates: [
                {
                    code: "Booking_Last_Service_Date",
                    name: "Service Date"
                },
                {
                    code: "Travel_Date",
                    name: "Travel Date"
                }
            ],
            totalCost: 0,
            totalInv:  0,
            totalReceipt: 0,
            pendingCost:  0,
        }
    },
    async created () {
        await this.getBookingAnalysis(); 
        await this.getBookingStatus();
        await this.getConsultants();
    },
    methods: {
        ...mapAppSettingActions(["LOADING_STATUS"]),
        async getBookingAnalysis(){            
            this.LOADING_STATUS(true);
            let response = await BookingService.getBookingAnalysis({
                "begDate" : this.date != '' ? this.date.start : "", //opcional
                "endDate" : this.date != '' ? this.date.end : "",//opcional
                "reference" : this.reference, //opcional
                "agencies" :    this.agencies, //opcional
                "consultants" : this.vendors, //opcional
                "booking_status": this.stBookings,
                "typeDate": this.typeDate
            });            
            if((response.status/100) == 2){
                this.bkAnalysis = response.data
            } 

            this.totalCost  = 0;
            this.totalInv   = 0;
            this.totalReceipt = 0;
            this.pendingCost  = 0;
            
            this.bkAnalysis.forEach(booking => {
                this.totalCost  = this.totalCost + booking.Expected_Sales_Inc
                this.totalInv   = this.totalInv  + booking.Actual_Sales_Inc
                this.totalReceipt = this.totalReceipt + booking.Booking_Receipt_Inc
                this.pendingCost  = this.pendingCost + (booking.Actual_Sales_Inc - booking.Booking_Receipt_Inc)
            });           
            this.LOADING_STATUS(false);
        },
        async getBookingStatus(){
            this.LOADING_STATUS(true);
            this.bookStatus = await CatalogService.getBookingStatus({});            
            this.LOADING_STATUS(false);
        },
        async getConsultants(){
            this.LOADING_STATUS(true);
            this.consultants = await CatalogService.getConsultants({});            
            this.LOADING_STATUS(false);
        },
        handlePagination (_paged) {
            this.filter.page = _paged    
            // this.retrieveProperties()
        },
        search() {
            this.getBookingAnalysis()
        },
        reset() {
            this.date = "";
            this.reference = "";
            this.agencies  = [];
            this.vendors   = [];
            this.stBookings = [];
            this.getBookingAnalysis();
        },
        async loadSuggestions(){
            this.suggestiondata = [];
            if(this.searchText != ''){
                let response = await CatalogService.getAgencies({ search: this.searchText});
                console.log('response', response)
                if((response.status/100) == 2){
                    this.suggestiondata = response.data
                    // this.searchText = ''
                }
            }
            // else{
            //     this.filter.supplierId = ""
            // }
        },
        itemSelected(index){
            // this.searchText = this.suggestiondata[index].NAME;
            if(this.agencies.findIndex(item => item.CODE == this.suggestiondata[index].CODE) < 0){
                this.agencies.push(this.suggestiondata[index])
            }
            this.suggestiondata = [];
            this.searchText = ''
        },
        removeAgency (item) {
            this.agencies.splice(this.agencies.indexOf(item), 1)
        },
    }
}
</script>